import axios from '@axios'

export const state = {
  models: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allModels: (state) => state.models,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_MODEL_STATE: (state) => {
    state.models = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  GET_MODELS: (state, resp) => {
    if (!resp) return null
    state.models = resp.models
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_MODEL: (state, model) => {
    model.id = new Date().getTime()
    state.models.push(model)
  },
  UPDATE_MODEL: (state, model) => {
    for (let i = 0; i < state.models.length; i++) {
      if (state.models[i].id === model.id) {
        model.id = new Date().getTime()
        for (let field in state.models[i]) {
          state.models[i][field] = model[field]
        }
        break
      }
    }
  },
  REMOVE_MODEL: (state, model) => {
    state.models = state.models.filter((m) => m.id !== model.id)
  },
}

export const actions = {
  async getModelsByMakeId({ commit }, makeId) {
    commit('CLEAR_MODEL_STATE')

    if (!makeId) return null

    await axios
      .get(`/api/makes/${makeId}/models`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_MODEL_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_MODELS', data)
        }
      })
      .catch(() => {
        commit('GET_MODELS', null)
      })
  },
  async getModels({ commit }) {
    commit('CLEAR_MODEL_STATE')
    await axios
      .get('/api/makes/models')
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_MODEL_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_MODELS', data)
        }
      })
      .catch(() => {
        commit('GET_MODELS', null)
      })
  },
  async createModel({ commit }, model) {
    return axios.post('/api/makes/models', model)
  },
  async updateModel({ commit }, model) {
    return axios.put('/api/makes/models', model)
  },
  async deleteModel({ commit, dispatch }, model) {
    await axios.delete('/api/makes/models', { data: model }).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_MODEL', model)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The model has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
